require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-fourdrinier-house-yarrabend-to-feature-super-stylish.json") })
        }
      }, "path---news-fourdrinier-house-yarrabend-to-feature-super-stylish");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-fourdrinier-house-yarrabend-to-feature-super-stylish!./.cache/json/news-fourdrinier-house-yarrabend-to-feature-super-stylish.json
// module id = 812
// module chunks = 231608221292675